/**
 * @author  : 王冲
 * @desc    : passport -- hooktools
 */
export interface HookType {
    // 钩子函数
    fn: Function;
    // 优先级
    priority?: number;
};

export type QueueType = {
    [key: string]: {
        [key: string]: HookType[];
    }
};
class HooksTool {
    constructor() { }
    // 状态数据
    private readyStateQueue: any = [];
    // 钩子队列
    private queue: QueueType = {};
    //hook初始函数
    private noop = () => { };
    //获取已注册的钩子
    public getHooks = (name?: string) => {
        let n = name;
        if (!n) return this.queue;
        let pos = n.split('.');
        return pos.reduce((d: any, key: any) => {
            if (Array.isArray(d)) {
                return d;
            } else if (d && key in d) {
                return d[key];
            }
            return d;
        }, this.queue)
    }
    public regHook = (name: string, fn: Function | HookType) => {
        // 将钩子加入到对应的数组中
        let fns = this.getHooks(name) || [];
        let priority = 0;
        if (!Array.isArray(fns)) {
            fns = []; // 重置成数组
        }
        // 处理默认值
        let hook: HookType = { fn: this.noop, priority, };
        if (typeof fn === 'object' && fn?.fn) {
            hook = { ...hook, ...(fn as HookType) };
        } else {
            hook = { ...hook, fn: fn as Function };
        }
        fns.push(hook);
        // 根据优先级排序
        fns.sort((x: any, y: any) => x.priority > y.priority ? 1 : -1);
        this.setHooks(name, fns);
    }
    public setHooks = (name: string, hook: HookType[]) => {
        let n = name;
        if (!n) return;
        let pos = n.split('.');
        let posLen = pos.length;
        let curr: any = this.queue;
        pos.forEach((key, index) => {
            if (posLen - 1 === index) {
                curr[key] = hook;
            } else {
                let oldValue = curr[key];
                if (oldValue && !Array.isArray(oldValue)) {
                    curr = oldValue;
                } else {
                    curr[key] = {};
                    curr = curr[key];
                }
            }
        });
    }
    //执行
    public getSyncHook = (name: any) => {
        let hooks = this.getHooks(name) || [];
        if (!Array.isArray(hooks) || !hooks.length) return null;
        return hooks.reverse().reduce(function (next, hook) {
            return function (data: any) {
                let _hook;
                let newData = ((_hook = hook.fn) === null || _hook === void 0 ? void 0 : _hook.call(hook, data)) || data;
                return (next === null || next === void 0 ? void 0 : next(newData)) || newData;
            };
        }, function (data: any) {
            return data;
        });
    }
    //获取缓存状态
    public getReadyState = (name: string) => {
        let readyState = this.readyStateQueue[name];
        if (!readyState) {
            // 初始化 ready state
            readyState = {
                loading: true,
                data: undefined,
                error: undefined,
            };
            this.readyStateQueue[name] = readyState;
        }
        return readyState;
    }
    //获取钩子调用
    public getReadyHooks = (readyHookName: string, callback: any) => {
        let readyState = this.getReadyState(readyHookName);
        if (readyState && readyState.loading) {
            if (callback && callback.success) {
                this.regHook(readyHookName + '.success', callback.success)
            }
            if (callback && callback.failed) {
                this.regHook(readyHookName + '.failed', callback.failed)
            }
        }
        else if (readyState.data) {
            callback.success?.(readyState.data);
        }
        // 如果 ready 执行失败
        else if (readyState.error) {
            callback.failed?.(readyState.error);
        }
    }
    //成功钩子
    public getReadySuccessHook = (name: string, data: any) => {
        // 获取 ready state
        let readyState = this.getReadyState(name);
        if (readyState?.loading) {
            // 设置loading状态
            readyState.loading = false;
            // 保存已加载的结果
            readyState.data = data;
            // 执行已缓存的钩子
            let doFun = this.getSyncHook(name + '.success');
            // if (doFun && name === 'TEAMS') {
            //     alert('执行TEAMS 回调 type:' + typeof doFun)
            // }
            doFun && doFun(data);
            // 清除缓存的钩子
            this.setHooks(name + '.success', []);
            this.setHooks(name + '.failed', []);
        }
    }
    //失败钩子
    public getReadyFailedHook = (name: string, error: any) => {
        // 获取 ready state
        let readyState = this.getReadyState(name);
        if (readyState && readyState.loading) {
            // 设置loading状态
            readyState.loading = false;
            // 保存已加载的结果
            readyState.error = error;
            // 执行已缓存的钩子
            let doFun = this.getSyncHook(name + '.failed');
            doFun && doFun(error);
            // 清除缓存的钩子
            this.setHooks(name + '.success', []);
            this.setHooks(name + '.failed', []);
        }
    }
}
export default HooksTool;